import React from 'react';
import { Button, Container, Row } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { STORAGE_PRODUCTS_CART } from "../../../utils/constants";

export default function FormularioWhat(props) {

    const{ itemCartWhap } = props;

  
    const formik = useFormik({
        initialValues:initialValues(),
        validationSchema: Yup.object(validationSchema()) , 
        onSubmit: (formData)=>{
            const arraytext = [];
            const arrayLink = [];
            let inicioText = "Hola querida Consultora, vi estos productos en el folleto y me gustaría pedirlos contigo los productos son: %0A";
            let text;
            let linkEnvio;
            let completText; 
            itemCartWhap.map((item, index) =>{
              text =`El producto numero ${index+1}: ${item.name}, de estos necesito: ${item.cantidad} por favor,%0A`;
              arraytext.push(text);
              linkEnvio=`${item.id}/${item.cantidad}`;
              arrayLink.push(linkEnvio);
            })
            let linkComplet = `%0Alink para agregar los productos: https://marykay.sv/revistaagregarproductos/${arrayLink.join("/")}`
            completText  = `${inicioText}${arraytext.join("-")}${linkComplet}`;
            let numero = `502${formData.numero}`;
            
            window.location.href=`https://api.whatsapp.com/send?phone='${numero}'&text=${completText}`;

            localStorage.removeItem(STORAGE_PRODUCTS_CART);

        }

    })

    const enviarMensaje = () =>{
        const arraytext = [];
        const arrayLink = [];
        let inicioText = "Hola querida Consultora, vi estos productos en el folleto y me gustaría pedirlos contigo los productos son: %0A";
        let text;
        let linkEnvio;
        let completText; 
        itemCartWhap.map((item, index) =>{
          text =`El producto numero ${index+1}: ${item.name}, de estos necesito: ${item.cantidad} por favor,%0A`;
          arraytext.push(text)
          linkEnvio=`${item.id}/${item.cantidad}`;
        arrayLink.push(linkEnvio);
        })
        let linkComplet = `%0Alink para agregar los productos: https://marykay.sv/revistaagregarproductos/${arrayLink.join("/")}`
        completText  = `${inicioText}${arraytext.join("-")}${linkComplet}`;
      window.location.href=`https://api.whatsapp.com/send?text=${completText}`;
      localStorage.removeItem(STORAGE_PRODUCTS_CART);
    }

    return (
        <Container>
            <Row>
                <form onSubmit={formik.handleSubmit}>
                
                <div className="form-group row">
                 <label for="inputEmail3" className="col-sm-2 col-form-label">Numero: </label>
                <div className="col-sm-10">
                <input 
                    type="number"
                    id="numero"
                    className="form-control form-control-lg"
                    name="numero"
                    placeholder="Numero de Whatsapp"
                    onChange={formik.handleChange}
                    error={formik.errors.numero}
                    min="0"
                    />
                    </div>
                </div>
                
                <div className="form-group row" >
                    <Button className="btn btn-primary col-5" type="submit" style={{"margin":"10px"}}>
                        Enviar a mi Consultora de Belleza con número
                    </Button>
                  
                    <Button className="btn btn-primary col-5" type="button" onClick={enviarMensaje} style={{"margin":"10px"}}>
                        Enviar a mi Consultora de Belleza buscando en mis contactos
                    </Button>
                    </div>
                </form>
            </Row>
        </Container>
    )
}

function initialValues() {
    return {
        numero:""
    }
}

function validationSchema(){
    return {
        numero: Yup.string().required("Necesita Enviar a un número")
    };
}